import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";
import { isSeriesOvertime } from "../../utils/overtime-utils";

export default class ExtraOvertime extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        // is Tied After End Of Current Overtime. Series overtime only: with
        // OT Kickoffs on the next period is the crew's call (PSTATS-1268).
        return (
            fragment.associatedState === FootballState.EndOfPlay &&
            gameContext.isATie() &&
            isSeriesOvertime(gameContext) &&
            gameContext.homeTeamOvertimeDrive &&
            gameContext.awayTeamOvertimeDrive
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.triggerExtraOvertime = true;
        gameContext.homeTeamOvertimeDrive = false;
        gameContext.awayTeamOvertimeDrive = false;
    }
}
